import utils from '@/base/utils'
export default function create_default_data() {
  return {
    id: utils.create_id(),
    name: '未命名海报',
    tags: '',
    userid: '',
    imgurl: null,
    shorturl: 'fei6ZvmMFramQvyIrurYbiIz',
    imgPath: null,
    state: null,
    statetime: null,
    showviewcount: true,
    timeinterval: 0,
    comment: 0,
    logo: null,
    logoPath: null,
    level: '',
    music: null,
    musicname: null,
    width: 375,
    height: 603,
    in: 'move',
    out: null,
    company: null,
    link: null,
    publish: 0,
    switch_guide: 1,
    gather: null,
    app_url: '',
    templateid: '',
    pages: {
      id: utils.create_id(),
      row: 0,
      col: 0,
      in: null,
      out: null,
      bgcol: null,
      bgimage: null,
      selectBgType: '1',
      bgserver: null,
      bgleft: 0,
      bgpositionx: 50, // 背景图片x轴位置，与bgleft一样，但是不能用bgleft，因为可能会和原来的数据冲突
      bgtop: 0,
      cmps: [],
      appid: utils.create_id(),
      createtime: '2021-12-07T15:23:53.620Z',
      updatetime: '2021-12-07T15:23:53.620Z'
    },
    app_form_attr: '',
    app_title: '',
    bucket: 'trueland',
    createtime: '2023-08-28T15:23:53.640Z',
    imgbucket: 'trueland',
    imgkey: '03ccc04b-f0e9-4e05-9262-3b53295e15cc',
    imgserver: 'A',
    key: null,
    logobucket: 'trueland',
    logokey: '',
    logoserver: '',
    server: '',
    updatetime: '2023-08-28T15:23:53.640Z',
    user_from: '',
    app_praise: 0,
    viewcount: 0,
    app_newdata: 0,
    app_apptitle: '',
    app_covers_filepath: '',
    app_ext: '',
    app_freeformcount: '',
    app_ismaterials: '',
    app_material: '',
    app_oldformcount: '',
    app_pfid: '',
    app_type: '1',
    owner: true,
    app_titles: '',
    app_titleshorturl: '',
    reportcount: ''
  }
}
